import { Serializable } from './../deserialize.service';
export class FilterElement implements Serializable<FilterElement> {
    type: string;
    subtypes: string[];
    value: string;
    caseElementType: string;

    deserialize(input) {
        this.type = input.type;
        this.subtypes = input.subtypes;
        this.value = input.value;
        this.caseElementType = input.caseElementType;
        return this;
    }
}
